<template>
    <div class="radio-invalid">
        <b-form-group
            class="kyc-status-radio overwrite-radio"
            :label="labelByInstance"
            :label-for="`id_${field._id}`"
            :class="{
                'required-field': requiredFields,
            }"
        >
            <b-form-radio-group
                v-model="model"
                v-validate="{
                    required: requiredFields,
                }"
                :options="field.options"
                :name="field._id"
                :disabled="loading"
                :data-vv-name="labelByInstance"
                :class="{
                    'is-invalid': errors.has(labelByInstance),
                }"
            ></b-form-radio-group>
        </b-form-group>
    </div>
</template>

<script>
import TextField from './TextField'
export default {
    // End of Component > inject

    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
    },
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: TextField, // End of Component > extends

    /*
    |--------------------------------------------------------------------------
    | Component > inject
    |--------------------------------------------------------------------------
    */
    inject: {
        $validator: '$validator',
    }, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        field: {
            type: Object,
            required: true,
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            textField: 'title',
            valueField: '_id',
            options: [],
            country:process.env.VUE_APP_COUNTRY
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        requiredFields()
        {
            if(["accountInfo.isf2f"].includes(this.field.key) 
                    && this.field.isRequired &&(( this.getField('type') && this.getField('type') =='individual') 
                    || !this.$route.path.includes('edit-profile')))
                 { 
                   return false
                 }
            return this.field.isRequired
        },
        labelByInstance() {
            // field.label
            if(this.$route.path.includes('company') || this.$store.getters.form.type=='company')
            {
                if (this.field.key == 'basicInfo.hasOtherNationalities') {
                    return 'Do you operate in any other countries?'
                }
                if (this.field.key == 'identityInfo.isLifetimeExpiry') {
                    return 'Do you have a Company Reg expiry date?'
                }
                else
                {
                    return this.field.label
                }

            }
            else
            {
                return this.field.label
            }

        },

    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {}, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {}, // End of Component > mounted
}
</script>
